<template>
    <div class="sticky top-0">
        <div class="flex items-center gap-2 px-6 py-4">
            <div class="my-0.5 flex items-center">
                <AppLogo :appName="appName" />
                <div class="headwayapp-widget h-8"></div>
            </div>
        </div>
        <nav class="flex flex-col justify-between">
            <div
                v-if="integrationsRequiringAttention"
                class="p-2 text-sm"
            >
                <Alert
                    type="danger"
                    title="Attention!"
                >
                    You have at least one integration that needs your attention.
                </Alert>
            </div>

            <ul class="space-y-0.5 text-sm px-2 py-4 p-4">
                <SidebarItem
                    iconName="home"
                    :href="RoutePathAppEnum.Root"
                    :active="currentRoute == RoutePathAppEnum.Root"
                >
                    Dashboard
                </SidebarItem>
                <SidebarItem
                    iconName="clock"
                    :href="RoutePathAppEnum.Availabilities"
                    :active="
                        currentRoute.startsWith(RoutePathAppEnum.Availabilities)
                    "
                >
                    Availability
                </SidebarItem>
                <SidebarItem
                    iconName="calendar"
                    :href="RoutePathAppEnum.Meetings"
                    :active="
                        currentRoute.startsWith(RoutePathAppEnum.Meetings) ||
                        currentRoute.startsWith(RoutePathAppEnum.Recurring)
                    "
                >
                    Meetings
                </SidebarItem>
                <SidebarItem
                    iconName="box"
                    :href="RoutePathAppEnum.Services"
                    :active="currentRoute.startsWith(RoutePathAppEnum.Services)"
                >
                    Services
                </SidebarItem>
                <SidebarItem
                    iconName="plug"
                    :href="RoutePathAppEnum.Integrations"
                    :active="
                        currentRoute.startsWith(RoutePathAppEnum.Integrations)
                    "
                >
                    Integrations
                </SidebarItem>
                <SidebarItem
                    iconName="bolt"
                    :href="RoutePathAppEnum.Automations"
                    :active="
                        currentRoute.startsWith(RoutePathAppEnum.Automations)
                    "
                >
                    Automations
                </SidebarItem>
                <SidebarItem
                    v-if="authCompanyUser.isAdminOrOwner()"
                    iconName="company"
                    :href="RoutePathAppEnum.Company"
                    :active="currentRoute.startsWith(RoutePathAppEnum.Company)"
                >
                    Company
                </SidebarItem>
            </ul>
        </nav>
    </div>
</template>

<script setup lang="ts">
    import SidebarItem from '@/Shared/Layout/App/Sidebar/SidebarItem.vue'
    import AppLogo from '@/Shared/Component/AppLogo.vue'
    import Alert from '@/Shared/Component/Alert.vue'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
    import User from '@/App/User/Entity/User'

    interface AppSidebarProps {
        appName: string
        currentRoute: string
        authUser: User
        authCompanyUser: CompanyUser
        integrationsRequiringAttention: number
    }

    const props = defineProps<AppSidebarProps>()
</script>
